import { TxpGriffinSettingsPayload } from 'owa-calendar-configuration';
import TxpSettingsEntryPoint from '../store/schema/TxpSettingsEntryPoint';

export default function getTxpSettingsSaveCustomData(
    body: TxpGriffinSettingsPayload,
    entryPoint: TxpSettingsEntryPoint
) {
    return {
        ...body.EntityTypeProcessorLevelSettings,
        entryPoint: entryPoint,
        createEventsAsPrivate: body.CreateEventsFromEmailAsPrivate,
    };
}
